export const serviceTypes = [
  {
    value:
      'File Case, Supplemental Pleadings, and Answers',
    label:
      'File Case, Supplemental Pleadings, and Answers',
  },
  {
    value:
      'Filing of Applications, Motions, or Requests',
    label:
      'Filing of Applications, Motions, or Requests',
  },
  {
    value: 'Other Services',
    label: 'Other Services',
  },
]
